import UserContext from "../ContextService/UserContext";
import { AppContext } from "../../context/AppContext";
import { useContext, useEffect, useState } from "react";
import { FaBirthdayCake } from "react-icons/fa";
import { ShowBirthDay } from "./ShowBirthDay";
import { useApiClient } from "../../ApiService/useApiClient";

const BirthDaysSection = () => {

  const api = useApiClient();
  const { user, token } = useContext(AppContext);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const apical_url = "HMCareDashboard/";

  useEffect(() => {
  
    const ApiCallData = async () => {
      try {
        const response = await api.get(apical_url + "upcomingbdays");
        setData(response.data);
      } catch (error) {
        setError(error);
      }
    };

    ApiCallData();
  }, []);

  return (
    <div className="card">
      <div className="card-header text-center bg-light py-1" style={{ backgroundColor: '#f1f2f7' }}>
        <h4 className="mb-0 d-inline-flex align-items-center gap-2">
          <FaBirthdayCake className="text-danger" />
          Upcoming Birthdays
        </h4>
      </div>

      <div className="card-body">
        {data && data.length > 0 ? (
          <ul className="list-unstyled mb-0">
            {data.map((bday, index) => (
              <li key={index} className="mb-2 d-flex align-items-center">
                <FaBirthdayCake className="text-warning me-2" />
                <div>
                  <strong>{bday.name}</strong>{" "}
                  <span className="text-muted">({ShowBirthDay(bday.birthday)})</span>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted text-center">No upcoming birthdays found.</p>
        )}
      </div>
    </div>
  );
};

export default BirthDaysSection;
